export default "__VITE_ASSET__CEctt9Pe__"